import { CheckboxInput } from '@frontend/components/basic-forms';

interface BoolFieldProps {
    id?: string;
    onChange: (value: boolean) => void;
    value: boolean;
    disabled?: boolean;
    className?: string;
    label?: React.ReactNode;
}

export const BoolField = (props: BoolFieldProps) => {
    return (
        <CheckboxInput
            {...props}
            label={props.label || 'Boolean'}
            value={props.value ?? false}
            onChange={props.onChange}
        />
    );
};
